import { Box, Flex } from "@chakra-ui/react";

const Divider = () => (
  <Flex my="8px">
    <Box borderBottom="2px dashed" borderColor="gray.200" width="100%" />
  </Flex>
);

export default Divider;
